import { useEffect, useRef, useState } from "react";

import { useDashboardStore } from "@/stores/useDashboardStore";

import { ApiResources } from "../../../../../api/resources";
import useGetInitialData from "../../../hooks/useGetInitialData";

const useCredits = () => {
  const { getInitialData } = useGetInitialData();

  const {
    credits: creditsData,
    setCredits,
    setCreditsError
  } = useDashboardStore();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getInitialData({
        setIsLoading,
        setDataState: setCredits,
        resource: ApiResources.DashboardCredits,
        initialized,
        setError: setCreditsError
      });
    }
  }, [getInitialData, setCredits, setCreditsError]);

  return { creditsData, isLoading };
};

export default useCredits;
